import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconGoogleCalendar = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 32 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M24.4211 7.57886H7.5791V24.4209H24.4211V7.57886Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M24.4211 31.9997L32.0001 24.4207L28.2106 23.7742L24.4211 24.4207L23.7295 27.8869L24.4211 31.9997Z",
			fill: "#EA4335"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M0 24.4207V29.4733C0 30.8692 1.1305 31.9997 2.52625 31.9997H7.579L8.35713 28.2102L7.579 24.4207L3.44988 23.7742L0 24.4207Z",
			fill: "#188038"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M32.0001 7.579V2.52625C32.0001 1.1305 30.8696 0 29.4739 0H24.4211C23.9601 1.8795 23.7296 3.26267 23.7295 4.1495C23.7295 5.03625 23.9601 6.17942 24.4211 7.579C26.0974 8.059 27.3606 8.299 28.2106 8.299C29.0607 8.299 30.3239 8.05906 32.0001 7.579Z",
			fill: "#1967D2"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M31.9999 7.57886H24.4209V24.4209H31.9999V7.57886Z",
			fill: "#FBBC04"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M24.4211 24.4211H7.5791V32.0001H24.4211V24.4211Z",
			fill: "#34A853"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M24.421 0H2.52638C1.1305 0 0 1.1305 0 2.52625V24.421H7.579V7.579H24.421V0Z",
			fill: "#4285F4"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11.0337 20.6439C10.4042 20.2186 9.96834 19.5976 9.73047 18.7764L11.1916 18.1744C11.3241 18.6796 11.5557 19.0712 11.8863 19.3491C12.2147 19.627 12.6147 19.7639 13.0821 19.7639C13.5599 19.7639 13.9704 19.6186 14.3136 19.328C14.6568 19.0375 14.8295 18.667 14.8295 18.2186C14.8295 17.7596 14.6484 17.3849 14.2863 17.0944C13.9242 16.8039 13.4695 16.6586 12.9263 16.6586H12.0821V15.2124H12.84C13.3073 15.2124 13.701 15.086 14.021 14.8333C14.341 14.5807 14.501 14.2354 14.501 13.7954C14.501 13.4039 14.3578 13.0923 14.0716 12.8586C13.7853 12.6249 13.4231 12.507 12.9831 12.507C12.5536 12.507 12.2126 12.6208 11.96 12.8501C11.7074 13.0802 11.5176 13.3707 11.4083 13.6944L9.96209 13.0922C10.1536 12.5491 10.5052 12.0691 11.021 11.6544C11.5367 11.2396 12.1957 11.0312 12.9957 11.0312C13.5873 11.0312 14.12 11.145 14.5916 11.3744C15.0631 11.6039 15.4336 11.9218 15.701 12.326C15.9685 12.7323 16.101 13.187 16.101 13.6923C16.101 14.208 15.9768 14.6439 15.7285 15.0017C15.4801 15.3596 15.1747 15.6332 14.8126 15.8249V15.9111C15.2802 16.1039 15.6863 16.4206 15.9873 16.827C16.2926 17.2375 16.4463 17.728 16.4463 18.3007C16.4463 18.8733 16.301 19.3849 16.0105 19.8333C15.72 20.2818 15.318 20.6354 14.8083 20.8923C14.2968 21.1491 13.7221 21.2797 13.0842 21.2797C12.3452 21.2817 11.6632 21.0691 11.0337 20.6439ZM20.0082 13.3933L18.4041 14.5533L17.602 13.3365L20.4798 11.2606H21.583V21.0523H20.0082V13.3933Z",
			fill: "#4285F4"
		})
	]
});
export default SvgIconGoogleCalendar;
